import React from 'react';
import { Flex, Divider, Typography, Switch } from '@banhala/ui-kit';
import { isNotNil } from 'shared/src/utils';

type Props = {
  title: string;
  description?: string | null;
  isOn: boolean;
  isLast: boolean;
  onToggle: () => void;
};

const SectionItem = ({ title, description, isOn, isLast, onToggle }: Props) => {
  return (
    <Flex.Column>
      <Flex.Row
        justifyContent={'space-between'}
        alignItems={'center'}
        padding={{ vertical: 12 }}
      >
        <Flex.Column gap={2} flex={1}>
          <Typography type="body1" color="content_primary">
            {title}
          </Typography>
          {isNotNil(description) && (
            <Typography type="body4" color="content_tertiary">
              {description}
            </Typography>
          )}
        </Flex.Column>
        <Flex padding={{ right: 4 }} flexShrink={0}>
          <Switch value={isOn} onChange={onToggle} />
        </Flex>
      </Flex.Row>
      {!isLast && (
        <Flex margin={{ horizontal: -16 }}>
          <Divider size="small" />
        </Flex>
      )}
    </Flex.Column>
  );
};

export default SectionItem;
